import {
  UPDATE_DATA_RETENTION_POLICY,
  UPDATE_DATA_RETENTION_POLICY_SUCCESS,
  UPDATE_DATA_RETENTION_POLICY_ERROR,
} from './actionTypes';

export const updateDataRetentionPolicy = (user, id, fields) => {
  return {
    type: UPDATE_DATA_RETENTION_POLICY,
    payload: { user, id, fields },
  };
};

export const updateDataRetentionPolicySuccess = (message) => {
  return {
    type: UPDATE_DATA_RETENTION_POLICY_SUCCESS,
    payload: { message },
  };
};

export const updateDataRetentionPolicyError = (msg) => {
  return {
    type: UPDATE_DATA_RETENTION_POLICY_ERROR,
    payload: msg,
  };
};
